/*
 * NativeCountries.js - A list of country names written in the most common
 * language of that country
 *
 * Copyright © 2022 JEDLSoft
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const nativeCountries = {
    "افغانستان": "AF",
    "ålandsøerne": "AX",
    "shqipëri": "AL",
    "algérie": "DZ",
    "الجزائر": "DZ",
    "principat d'andorra": "AD",
    "república de angola": "AO",
    "repubilika ya ngola": "AO",
    "Հայաստան": "AM",
    "österreich": "AT",
    "azərbaycan": "AZ",
    "البحرين": "BH",
    "বাংলাদেশ": "BD",
    "গণপ্রজাতন্ত্রী বাংলাদেশ": "BD",
    "gônoprojatontri bangladesh": "BD",
    "беларусь": "BY",
    "belgië": "BE",
    "la belgique": "BE",
    "belgique": "BE",
    "république du bénin": "BJ",
    "bénin": "BJ",
    "འབྲུག་ཡུལ་": "BT",
    "bulivya mamallaqta": "BO",
    "estado plurinacional de bolivia": "BO",
    "wuliwya suyu": "BO",
    "bosna i hercegovina": "BA",
    "босна и херцеговина": "BA",
    "lefatshe la botswana": "BW",
    "bouvetøya": "BV",
    "brasil": "BR",
    "negara brunei darussalam": "BN",
    "българия": "BG",
    "republika y'u burundi": "BI",
    "république du burundi": "BI",
    "ព្រះរាជាណាចក្រកម្ពុជា": "KH",
    "preăh réachéanachâk kâmpŭchéa": "KH",
    "kâmpŭchéa": "KH",
    "cameroun": "CM",
    "cabo verde": "CV",
    "islas de cabo verde": "CV",
    "république centrafricaine": "CF",
    "ködörösêse tî bêafrîka": "CF",
    "république du tchad": "TD",
    "tchad": "TD",
    "جمهورية تشاد": "TD",
    "ǧumhūriyyat tšād": "TD",
    "tšād": "TD",
    "中华人民共和国中国": "CN",
    "共和國的中國": "TW",
    "台灣的": "TW",
    "中国": "CN",
    "union des comores": "KM",
    "udzima wa komori": "KM",
    "日本":"JP",
    "الاتحاد القمري": "KM",
    "al-ittiḥād al-qumurī/qamarī": "KM",
    "république du congo": "CG",
    "repubilika ya kongo": "CG",
    "republiki ya kongó": "CG",
    "kongo": "CG",
    "kongó": "CG",
    "république démocratique du congo": "CD",
    "kūki 'āirani": "CK",
    "cote-d'ivoire": "CI",
    "côte-d'ivoire": "CI",
    "hrvatska": "HR",
    "κυπριακή δημοκρατία": "CY",
    "kypriakí dimokratía": "CY",
    "kıbrıs cumhuriyeti": "CY",
    "česká republika": "CZ",
    "danmark": "DK",
    "جمهورية جيبوتي": "DJ",
    "jumhūriyyat jībūtī": "DJ",
    "république de djibouti": "DJ",
    "jamhuuriyadda jabuuti": "DJ",
    "gabuutih ummuuno": "DJ",
    "jībūtī": "DJ",
    "djibouti": "DJ",
    "jabuuti": "DJ",
    "gabuutih": "DJ",
    "Commonwealth de la Dominique": "DM",
    "Dominique": "DM",
    "república dominicana": "DO",
    "مصر": "EG",
    "república de guinea ecuatorial": "GQ",
    "république de guinée équatoriale": "GQ",
    "guinea ecuatorial": "GQ",
    "guinée équatoriale": "GQ",
    "ሃገረ ኤርትራ": "ER",
    "hagere ertra": "ER",
    "دولة إرتريا": "ER",
    "dawlat iritrīya": "ER",
    "eesti": "EE",
    "የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ": "ET",
    "ye-ītyōṗṗyā fēdēralāwī dīmōkrāsīyāwī rīpeblīk": "ET",
    "የኢትዮጵያ": "ET",
    "ye-ītyōṗṗyā": "ET",
    "malvinas": "FK",
    "færøerne": "FO",
    "matanitu ko viti": "FJ",
    "fijī ripablik": "FJ",
    "फ़िजी गणराज्य": "FJ",
    "suomi": "FI",
    "guyane française": "GF",
    "polynésie française": "PF",
    "terres australes françaises": "TF",
    "république gabonaise": "GA",
    "საქართველოს": "GE",
    "deutschland": "DE",
    "ελλάδα": "GR",
    "grønland": "GL",
    "république de guinée": "GN",
    "república da guiné-bissau": "GW",
    "haïti": "HT",
    "ayiti": "HT",
    "santa sede": "VA",
    "città del vaticano": "VA",
    "vaticano": "VA",
    "香港的": "HK",
    "magyarország": "HU",
    "ísland": "IS",
    "भारत": "IN",
    "جمهوری اسلامی ایران": "IR",
    "ایران": "IR",
    "العراق": "IQ",
    "éire": "IE",
    "ישראל": "IL",
    "italia": "IT",
    "الأردن": "JO",
    "Казахстан": "KZ",
    "jamhuri ya kenya": "KE",
    "ribaberiki kiribati": "KI",
    "조선 민주주의 인민 공화국": "KP",
    "북한": "KP",
    "대한민국": "KR",
    "한국": "KR",
    "الكويت": "KW",
    "кыргыз республикасы": "KG",
    "kırgız respublikası": "KG",
    "кыргызская республика": "KG",
    "kyrgyzskaya respublika": "KG",
    "ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ": "LA",
    "sathalanalat paxathipatai paxaxon lao": "LA",
    "latvija": "LV",
    "لبنان": "LB",
    "muso oa lesotho": "LS",
    "ليبيا": "LY",
    "lietuva": "LT",
    "luxemburg": "LU",
    "macau": "MO",
    "澳门": "MO",
    "澳門": "MO",
    "поранешна југословенска република македонија": "MK",
    "македонија": "MK",
    "repoblikan'i madagasikara": "MG",
    "république de madagascar": "MG",
    "chalo cha malawi": "MW",
    "dziko la malaŵi": "MW",
    "malaŵi": "MW",
    "ދިވެހިރާއްޖޭގެ ޖުމްހޫރިއްޔާ": "MV",
    "dhivehi raa'jeyge jumhooriyya": "MV",
    "république du mali": "ML",
    "mali ka fasojamana": "ML",
    "الجمهورية الإسلامية الموريتانية": "MR",
    "al-ǧumhūriyyah al-ʾislāmiyyah al-mūrītāniyyah": "MR",
    "république islamique de mauritanie": "MR",
    "republik bu lislaamu bu gànnaar": "MR",
    "republik moris": "MU",
    "république de maurice": "MU",
    "méxico": "MX",
    "republica moldova": "MD",
    "mongγol ulus": "MN",
    "монгол улс": "MN",
    "mongol uls": "MN",
    "crna gora": "ME",
    "црна гора": "ME",
    "مغربي": "MA",
    "república de moçambique": "MZ",
    "moçambique": "MZ",
    "pyidaunzu thanmăda myăma nainngandaw": "MM",
    "burma": "MM",
    "republiek van namibië": "NA",
    "republik namibia": "NA",
    "namibië": "NA",
    "ripublik naoero": "NR",
    "सङ्घीय लोकतान्त्रिक गणतन्त्र नेपाल": "NP",
    "sanghiya loktāntrik ganatantra nepāl": "NP",
    "nepāl": "NP",
    "nederland": "NL",
    "nouvelle-calédonie": "NC",
    "la calédonie": "NC",
    "calédonie": "NC",
    "aotearoa": "NZ",
    "jamhuriyar nijar": "NE",
    "nijar": "NE",
    "jamhuriyar tarayyar najeriya": "NG",
    "njíkọtá ọchíchìiwú nàịjíríà": "NG",
    "àpapọ̀ olómìnira ilẹ̀ nàìjíríà": "NG",
    "nàịjíríà": "NG",
    "nàìjíríà": "NG",
    "norge": "NO",
    "سلطنة عمان": "OM",
    "پاکستان": "PK",
    "beluu ęr a belau": "PW",
    "belau": "PW",
    "panamá": "PA",
    "independen stet bilong papua niugini": "PG",
    "papua niugini": "PG",
    "perú": "PE",
    "las filipinas": "PH",
    "filipinas": "PH",
    "polska": "PL",
    "قطر": "QA",
    "românia": "RO",
    "русский Федерации": "RU",
    "россия": "RU",
    "repubulika y'u rwanda": "RW",
    "république du rwanda": "RW",
    "saint-barthélemy": "BL",
    "saint barth": "BL",
    "saint-martin": "MF",
    "sint maarten": "MF",
    "saint-pierre-et-miquelon": "PM",
    "malo sa'oloto tuto'atasi o samoa": "WS",
    "san marino": "SM",
    "sao tome and principe": "ST",
    "sao tome & principe": "ST",
    "sao tome": "ST",
    "principe": "ST",
    "السعودية جزيره العرب": "SA",
    "arabia": "SA",
    "senegal": "SN",
    "sénégal": "SN",
    "serbia": "RS",
    "seychelles": "SC",
    "sierra leone": "SL",
    "新加坡共和国": "SG",
    "新加坡的": "SG",
    "slovensko": "SK",
    "slovenija": "SI",
    "solomon islands": "SB",
    "solomons": "SB",
    "somalia": "SO",
    "suid-afrika": "ZA",
    "españa": "ES",
    "sri lanka": "LK",
    "the sudan": "SD",
    "sudan": "SD",
    "suriname": "SR",
    "svalbard and jan mayen": "SJ",
    "svalbard & jan mayen": "SJ",
    "svalbard": "SJ",
    "jan mayen": "SJ",
    "swaziland": "SZ",
    "sverige": "SE",
    "die schweiz": "CH",
    "schweiz": "CH",
    "la suisse": "CH",
    "suisse": "CH",
    "svizzera": "CH",
    "سوريا": "SY",
    "taiwan, province of china": "TW",
    "taiwan": "TW",
    "tajikistan": "TJ",
    "tanzania, united republic of": "TZ",
    "united republic of tanzania": "TZ",
    "tanzania": "TZ",
    "ประเทศไทย": "TH",
    "timor-leste": "TL",
    "east timor": "TL",
    "togo": "TG",
    "tokelau": "TK",
    "tonga": "TO",
    "trinidad and tobago": "TT",
    "trinidad & tobago": "TT",
    "trinidad": "TT",
    "tobago": "TT",
    "تونس": "TN",
    "türkiye": "TR",
    "turkmenistan": "TM",
    "tuvalu": "TV",
    "uganda": "UG",
    "україна": "UA",
    "الامارات العربية المتحدة": "AE",
    "دبي": "AE",
    "albain": "GB",
    "cymru": "GB",
    "uruguay": "UY",
    "uzbekistan": "UZ",
    "vanuatu": "VU",
    "việt nam": "VN",
    "western sahara": "EH",
    "republika e kosovës": "XK",
    "република косово": "XK",
    "republika kosovo": "XK",
    "kosovës": "XK",
    "косово": "XK",
    "kosovo": "XK",
    "يمني": "YE",
    "zambia": "ZM",
    "zimbabwe": "ZW"
};
